import SlimSelect from '../vendor/SlimSelect';

export default class Filters {
  constructor($element) {
    this.$element = $element;

    const selects = Array.from(this.$element.querySelectorAll('.js-filters-select'));
    this.Selects = selects.map(($select) => new SlimSelect(
      {
        select: $select,
        settings: {
          placeholderText: $select.dataset.placeholder,
          showSearch: false,
        },
        events: {
          afterChange: this.onFiltersSelectChange.bind(this),
        },
    }));
  }

  onFiltersSelectChange(values) {
    const url = this.buildUrlFromFilters(values);
    window.redirect(url);
  }

  buildUrlFromFilters(filters) {
    let url = this.$element.dataset.root;
    const params = {};
    filters.forEach( filter => {
      const values = filter.value.split('__');
      let key = values[0];
      let val = values[1];

      if (params.hasOwnProperty(key))
        params[key].push(val);
      else
        params[key] = [val];
    });

    if (Object.keys(params).length) url += '?';

    var output = [];
    for (const key in params) {
      output.push(key + '=' + params[key].join(','));
    }
    url += output.join('&');

    return url;
  }

}



// WEBPACK FOOTER //
// ./scripts/dom/Filters.js